import axios from "axios";

const actions = {
  globalActionMPPFetchResults: (context, dataObject) => {
    return new Promise((resolve, reject) => {
      //set fetching state to show spinner in other areas
      //context.dispatch('setMPPFetchingResultsNow', true); //we don't want it globally as not in all circumstances - egen when clicking on load more we want this behavior to eliminate all results

      //prepare URL
      //const myURL         = this.wpData.fm_admin_ajax_url;
      const mppAjaxURL = "?action=fm_vue_frontend_api_fetch_results";


      //check if we are paginating or loading more data
      let loadMoreSwitch = false;
      if(typeof dataObject != 'undefined' && dataObject.filterPaginate == 'true'){
        loadMoreSwitch = true;
      }

      //prepare filter data to be passed - filterdata must be JSON ... form data can not work with objects
      const reqData = {
        action:                 'fm_vue_frontend_api_fetch_results',
        filterChannel:          JSON.stringify(context.getters.getMPPChannels),
        filterStarRating:       JSON.stringify(context.getters.getMPPStars),
        filterNumResPerPage:    context.getters.getMPPResultsPerPageObject.selected,
        filterSearchPhrase:     context.getters.getMPPSearchPhrase,
        filterSearchInText:     context.getters.getMPPSearchInText,
        filterSearchInTitle:    context.getters.getMPPSearchInTitle,
        forceFetchTotalResults: context.getters.getMPPForceFetchTotalNumberOfResults,
        filterResCurrentPage:   context.getters.getMPPResultCurrentPage,
        filterPaginate:         loadMoreSwitch,
        filterTaxonomy:         ''
      };

      //console.log(reqData);

      //turn DATA into FormData to be able to read it via POST on PHP End
      const reqFormData = new FormData();
      for (var key in reqData) {
        reqFormData.append(key, reqData[key]);
      }

      //contact MPP Backend To Get Filter Data
      axios.post(mppAjaxURL, reqFormData) //example for passing in configuration via 3rd optional parameter.
           .then(response => {

             if(typeof dataObject != "undefined" && dataObject.responseMode == 'add'){
                //attach results
                context.dispatch('addMPPResults', response.data.results);
             } else {
                //replace results as no mode is provided or more is not add
                context.dispatch('setMPPResults', response.data.results);
             }

             context.dispatch('setMPPCurrentPage', response.data.info['current_page']);
             context.dispatch('setMPPFilteredResultsNum', response.data.info['total_num_results_filtered']);

             //set fetching sate back to false
             context.dispatch('setMPPFetchingResultsNow', false);

             //return results
             resolve(response);
           })
           .catch(error => {
             //this.loadingInitialResults = false;
             console.log(error);
             reject(error);
           });
    });
  }
};

export default {
  actions
}